import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-16-箭头-实心-下拉",
  "use": "icon-16-箭头-实心-下拉-usage",
  "viewBox": "0 0 12 6",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 12 6\" id=\"icon-16-箭头-实心-下拉\">\n<style type=\"text/css\">\n\t#icon-16-箭头-实心-下拉 .st0{fill-rule:evenodd;clip-rule:evenodd;fill:#A9B8A9;}\n</style>\n<g>\n\t<path class=\"st0\" d=\"M0,0h12L6,6L0,0z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol